export default __webpack_public_path__ + "static/media/delete.946ff1da.png";